import request, { CommonListResponse, IListWorkspaceResponse, IPage, IWorkspaceResponse } from '/@/api/http/request'

// 算法告警
export const getAlgorithmAlarmListPageVo = async function (body: {}): Promise<IWorkspaceResponse<any>> {
  const url = 'accessAlarm/algorithmCenter/getAlgorithmAlarmListPageVo'
  const result = await request.post(url, body)
  return result.data
}
// 算法任务添加
export const addAlgorithmTask = async function (body: {}): Promise<IWorkspaceResponse<any>> {
  const url = 'accessAlarm/algorithmCenter/addAlgorithmTask'
  const result = await request.post(url, body)
  return result.data
}
// 查看模型（分页）
export const getAlgorithmModelListPageVo = async function (body: {}): Promise<IWorkspaceResponse<any>> {
  const url = 'accessAlarm/algorithmCenter/getAlgorithmModelListPageVo'
  const result = await request.post(url, body)
  return result.data
}
// 查看任务列表
export const getAlgorithmTaskListPageVo = async function (body: {}): Promise<IWorkspaceResponse<any>> {
  const url = 'accessAlarm/algorithmCenter/getAlgorithmTaskListPageVo'
  const result = await request.post(url, body)
  return result.data
}
// 启动/停止任务
export const setAlgorithmTaskStatus = async function (body: {}): Promise<IWorkspaceResponse<any>> {
  const url = 'accessAlarm/algorithmCenter/setAlgorithmTaskStatus'
  const result = await request.post(url, body)
  return result.data
}
// 标记错误告警
export const flagMisreportByAlgorithmAlarm = async function (body: {}): Promise<IWorkspaceResponse<any>> {
  const url = 'accessAlarm/algorithmCenter/flagMisreportByAlgorithmAlarm'
  const result = await request.post(url, body)
  return result.data
}
// 标记错误告警 --新接口
export const setAlarmStatus = async function (body: {}): Promise<IWorkspaceResponse<any>> {
  const url = '/manage/api/v1/alarmData/setAlarmStatus'
  const result = await request.post(url, body)
  return result.data
}
export const BatchSetAlarmStatus = async function (body: {}): Promise<IWorkspaceResponse<any>> {
  const url = '/manage/api/v1/alarmData/batchSetAlarmStatus'
  const result = await request.post(url, body)
  return result.data
}
